const VersionInfo = {
	version: "2.20.0",
	major: 2,
	minor: 20,
	patch: 0,
	suffix: "",
	isNext: false,
	buildTime: 1772704608,
};
export default VersionInfo;